import React from "react";
import './terms.css';


function TermsSection({ number, title, description, points }) {

  return (
    <section className="terms-section">

      <h3 className="terms-heading">
        {number}. {title}
      </h3>


      {description && (
        <p>
          {description}
        </p>
      )}


      {points.length > 0 && (
        <ul className="terms-list">

          {points.map((point, index) => (
            <li 
              key={index}
              className="terms-list-item"
            >
              {point}
            </li>
          ))}

        </ul>
      )}

    </section>
  );
}


export default TermsSection;